import React from 'react';
import './Home.css'
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import About from '../sections/About';
import PracticeAreas from '../sections/PracticeAreas';
import WhyChooseUs from '../sections/WhyChooseUs';
import MetOurTeam from '../sections/MeetOurTeam';
import Contact from '../sections/Contact';
import Footer from '../sections/Footer';
import ScrollToTop from '../components/ScrollToTop';


const Home = () => {
    return ( <>
    <div>
    <Navbar />
    <Header />
    <About />
    <PracticeAreas />
    <WhyChooseUs />
    <MetOurTeam />
    <Contact />
    <Footer />
    <ScrollToTop />
    </div>

    </> );
}
 
export default Home;